import React from 'react';
import I18n from 'hooks/useI18n';
import './style.scss';

import Loading from '../common/loaders/Loader';

export default class LoadingPage extends React.PureComponent {
  render() {
    if (this.props.loadingByRoute) {
      return <Loading msg={I18n.t('Loading')} className="loading-by-route" />;
    }
    return (
      <div>
        <Loading msg={I18n.t('Loading')} />
      </div>
    );
  }
}
